import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { useApi } from './../../hooks/useApi';
import TableWithPagination from './../common/TableWithPagination';
import EstadoBloqueoBadge  from './../common/EstadoBloqueoBadge';

const HistorialProceso = ({ proceso, onBack }) => {
    const { get, post, loading, error } = useApi();
    const [historial, setHistorial] = useState([]);
    const formatDate = (date) => (date ? dayjs(date).format('DD/MM/YYYY HH:mm') : '');

    useEffect(() => {
        const fetchHistorial = async () => {
        const data = await get('HistoriaProceso', { urlParams: { id: proceso.id } });
        setHistorial(data);
        };
        fetchHistorial();
    }, [proceso]); 

    const columnsHistoria = [
        { header: 'ID', accessor: 'id' },
        { header: 'Estatus', accessor: 'estadoBloqueo',
            
            Cell: ({ value }) => <EstadoBloqueoBadge estado={value} />
         },
        { header: 'Fecha inicio', accessor: 'startDate' },
        { header: 'Fecha Fin', accessor: 'endDate' },
        { header: 'Usuario', accessor: 'nombre' },
        { header: 'Comentarios', accessor: 'comment' },
        { header: 'Creado', accessor: 'createdAt' },
    ];
      
  return (
    <div className="p-4 relative">
        <div className="flex items-center justify-center mb-4 relative">
            <button
            onClick={onBack}
            className="absolute left-0 text-blue-600 hover:underline"
            >
            ← Volver a procesos
            </button>

            <h2 className="text-xl font-semibold text-center">
            Historial de: {proceso.procesoNombre}
            </h2>
        </div>

        {historial.length > 0 ? (
            <TableWithPagination
            columns={columnsHistoria}
            data={historial.map((p) => ({
                ...p,
                startDate: formatDate(p.startDate),
                endDate: formatDate(p.endDate),
                createdAt: formatDate(p.createdAt),
            }))}
            showView={false}
            showEdit={false}
            showDelete={false}
            />
        ) : (
            <p className="text-gray-500">No hay historial para este proceso.</p>
        )}
    </div>

  );
};

export default HistorialProceso;